import type { TenantDto, UpdateTenantSettingsRequest } from '@/types/tenantSettings';

/** The vehicle settings of the tenant settings page (FAFD-68), flat in its form state. */
export interface VehicleSettingsForm {
  allowPrivateTrips: boolean;
  tripStartRequired: boolean;
  tripDestinationRequired: boolean;
  tripPurposeRequired: boolean;
  flagTripsOutsideWorkingTime: boolean;
}

export type VehicleSettingsChange = <K extends keyof VehicleSettingsForm>(
  key: K,
  value: VehicleSettingsForm[K],
) => void;

/** Same defaults as the backend: today's behaviour — destination and purpose required, start not. */
export const DEFAULT_VEHICLE_SETTINGS: VehicleSettingsForm = {
  allowPrivateTrips: false,
  tripStartRequired: true,
  tripDestinationRequired: true,
  tripPurposeRequired: true,
  flagTripsOutsideWorkingTime: true,
};

export function vehicleSettingsFromTenant(tenant: TenantDto): VehicleSettingsForm {
  const d = DEFAULT_VEHICLE_SETTINGS;
  return {
    allowPrivateTrips: tenant.allowPrivateTrips ?? d.allowPrivateTrips,
    tripStartRequired: tenant.tripStartRequired ?? d.tripStartRequired,
    tripDestinationRequired: tenant.tripDestinationRequired ?? d.tripDestinationRequired,
    tripPurposeRequired: tenant.tripPurposeRequired ?? d.tripPurposeRequired,
    flagTripsOutsideWorkingTime: tenant.flagTripsOutsideWorkingTime ?? d.flagTripsOutsideWorkingTime,
  };
}

/**
 * The vehicle part of the save payload. All fields always go along — a missing one would make the
 * backend fall back to its default and silently undo the tenant's choice.
 */
export function vehicleSettingsPayload(
  form: VehicleSettingsForm,
): Pick<UpdateTenantSettingsRequest, keyof VehicleSettingsForm> {
  return {
    allowPrivateTrips: form.allowPrivateTrips,
    tripStartRequired: form.tripStartRequired,
    tripDestinationRequired: form.tripDestinationRequired,
    tripPurposeRequired: form.tripPurposeRequired,
    flagTripsOutsideWorkingTime: form.flagTripsOutsideWorkingTime,
  };
}
